import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Btn } from '../../../../../components'
import * as Maps from '../../../../../services/Maps'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOAD_MAP: 'Carregando Mapa',
}

function ModalMapCliente({ coordinates, setCoordinates, onSave, dispatch, readOnly = false }) {
  const [errorMessage, setErrorMessage] = useState(null)
  const [loadingMessage, setLoadingMessage] = useState(LOAD_MESSAGE.LOAD_MAP)

  useEffect(() => {
    switch (loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.LOAD_MAP:
        dispatch(showLoadingBox('Aguarde...', loadingMessage))
        break

      default:
        break
    }
  }, [loadingMessage])

  useEffect(() => {
    if (errorMessage) {
      dispatch(showMessageBox(null, errorMessage))
      setErrorMessage(null)
    }
  }, [errorMessage])

  const changeLoadStatusOnMapFullyLoaded = () => {
    setLoadingMessage(LOAD_MESSAGE.NONE)
  }

  return (
    <div className="p-grid" style={{ height: 'fit-content', marginTop: 0 }}>
      <div className="p-col-12" style={{ fontWeight: 'bolder' }}>
        O marcador preto indica a posição do cliente, você pode arrasta-lo para melhorar a precisão.
      </div>
      <div className="p-col-12" style={{ height: 400 }}>
        <Maps.MapWithSingleMarker
          coordinates={coordinates}
          setCoordinates={setCoordinates}
          loadStatus={changeLoadStatusOnMapFullyLoaded}
        />
      </div>
      {!readOnly && (
        <div className="p-col-12">
          <Btn onClick={onSave}>Salvar</Btn>
        </div>
      )}
    </div>
  )
}

export default connect()(ModalMapCliente)
